import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['CR', 'Carmen R.', 'Buenos Aires', '3 años con omeprazol. A los 10 días la pesadez desapareció. No lo podía creer.'], ['RS', 'Roberto S.', 'Córdoba', 'Todo lo conseguí en el super de mi barrio. Sin productos raros ni fortunas.'], ['MP', 'Mirta P.', 'Rosario', 'El cronograma de 30 días fue lo que me faltaba. Mi intestino finalmente respondió.']];
const extended = [['Carmen R.', 'Buenos Aires', '“3 años con omeprazol. A los 10 días la pesadez bajó tanto que no lo podía creer. Por fin mi cuerpo me respondió.”'], ['Roberto S.', 'Córdoba', '“La Lista de Compras me cambió la vida. Todo en el Coto de mi barrio, sin gastar fortunas en dietéticas.”'], ['Mirta P.', 'Rosario', '“Detecté mis detonantes y mi intestino finalmente empezó a sanar de verdad.”'], ['Diego F.', 'Mendoza', '“Empecé con escepticismo. Al día 8 el ardor nocturno bajó notablemente. Se lo recomiendo a cualquiera.”']];
export function StatsAndProof() {
  const stats = [['+250', 'personas ya recuperaron su digestión'], ['5', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.9/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-168">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-169">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-170">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-171">
                {value}
              </p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-172">
                {label}
              </p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-173">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-174">
          {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-175">
              <div className="flex items-center gap-3" data-id="element-176">
                <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-177">
                  {initials}
                </div>
                <div data-id="element-178">
                  <h3 className="font-bold" data-id="element-179">{name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-180">{place}</p>
                </div>
              </div>
              <div className="mt-5 flex gap-1 text-brand-gold" data-id="element-181">
                {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" data-id="element-182" />)}
              </div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-183">
                “{quote}”
              </p>
            </motion.article>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-184">
      <div className="mx-auto max-w-5xl" data-id="element-185">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-186">
          LO QUE DICEN LOS QUE YA LO TIENEN
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-187">
          {extended.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-188">
              <div className="mb-2 flex items-center gap-1 text-sm text-brand-gold" data-id="element-189">
                {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-3.5 w-3.5 fill-current" data-id="element-190" />)}
              </div>
              <p className="font-bold" data-id="element-191">
                {name}{' '}
                <span className="font-normal text-slate-400" data-id="element-192">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-193">
                {quote}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}